import { PatientRepository } from '../domain/repositories/PatientRepository'
import { PatientDatasource } from './PatientDatasource'

export const patientRepositoryAdapter = (
  patientDatasource: PatientDatasource
): PatientRepository => {
  return {
    async getTherapistPatientList(personaId) {
      return await patientDatasource.getTherapistPatientList(personaId)
    },
    async getOperatorPatientList() {
      return await patientDatasource.getOperatorPatientList()
    },
    async getResponsiblePatientList() {
      return await patientDatasource.getResponsiblePatientList()
    },
    async ListPatientResponsibles(patientId: string) {
      return await patientDatasource.ListPatientResponsibles(patientId)
    },
    async getPatient(id) {
      return await patientDatasource.getPatient(id)
    },
    async createPatient(data) {
      await patientDatasource.createPatient(data)
    },
    async activatePatient(patientId: string) {
      return await patientDatasource.activatePatient(patientId)
    },
    async deactivatePatient(patientId: string) {
      return await patientDatasource.deactivatePatient(patientId)
    }
  }
}
